// extracted by mini-css-extract-plugin
module.exports = {"ToolbarFooter":"ToolbarFooter__ToolbarFooter__25Asu","Logo":"ToolbarFooter__Logo__1Sin1"};